import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import type { ResultObservable } from "@mastechnicaegroup/carelinelive-cdk/rx";
import { toResult } from "@mastechnicaegroup/carelinelive-cdk/rx";
import { delay, map, shareReplay } from "rxjs/operators";
import type { ApiResponse } from '@shared/http/responses/api-response';

export interface SingleSignOnConnection {
    id: string;
    type: 'google' | 'microsoft-entra' | 'microsoft-entra-oidc';
    login_button_text: string;
    redirect_uri: string;
}

export interface SingleSignOnConnectionState {
    email: string;
    clients: SingleSignOnConnection[];
    allow_password: boolean;
}

@Injectable({ providedIn: 'root' })
export class SingleSignOnService {
    private readonly _http = inject(HttpClient);

    public getConnections(email: string): ResultObservable<SingleSignOnConnectionState> {
        return this._http.get<ApiResponse<SingleSignOnConnection[]>>('/auth/sso/connections', {
            params: { email }
        }).pipe(
            map(response => ({
                email,
                clients: response.data,
                allow_password: response.meta.allow_password,
            })),
            toResult(),
            shareReplay(1),
        )
    }
}
